import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, forwardRef, isValidElement, useMemo, } from 'react';
import classNames from 'clsx';
import { Typography } from "../../foundation/typography/typography";
import { Image } from "../image/image";
import css from "./choice-chip.module.css";
export const ChoiceChip = forwardRef(({ type, name, value, children, className, ...restProps }, ref) => {
    const inputId = `${name}-${value}-input`;
    const labelId = `${name}-${value}-label`;
    const iconOnly = useMemo(() => Children.toArray(children)
        .filter(isValidElement)
        .every(child => child.type?.displayName ===
        ChoiceChipIcon.displayName), [children]);
    return (_jsxs("div", { className: classNames(css.root, className), children: [_jsx("input", { ...restProps, ref: ref, id: inputId, "aria-labelledby": labelId, name: name, value: value, className: css.input, type: type }), _jsx("label", { htmlFor: inputId, id: labelId, "aria-hidden": true, className: classNames(css.label, type === 'checkbox' ? css.multi : css.single, iconOnly && css.iconOnly), children: children })] }));
});
ChoiceChip.displayName = 'ChoiceChip';
export const ChoiceChipText = ({ children, className, ...restProps }) => (_jsx(Typography, { variant: "body-regular", as: "span", className: classNames(css.text, className), ...restProps, children: children }));
ChoiceChipText.displayName = 'ChoiceChipText';
export const ChoiceChipIcon = ({ children, className, ...restProps }) => (_jsx("span", { className: classNames(css.icon, className), "aria-hidden": true, ...restProps, children: children }));
ChoiceChipIcon.displayName = 'ChoiceChipIcon';
export const ChoiceChipImage = ({ className, ...restProps }) => (_jsx(Image, { className: classNames(css.imageContainer, className), resize: "fill", alt: "", "aria-hidden": true, ...restProps }));
ChoiceChipImage.displayName = 'ChoiceChipImage';
export const ChoiceChipGroup = ({ className, children, ...restProps }) => {
    return (_jsx("fieldset", { className: classNames(css.group, className), ...restProps, children: children }));
};
ChoiceChipGroup.displayName = 'ChoiceChipGroup';
